import React from 'react';
import { styled } from '@compiled/react';
import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';
import type { ProjectPickerOption } from '../../common/types.tsx';

interface Props {
	value: ProjectPickerOption;
}

export const SingleProjectOption = ({ value }: Props) => (
	<SingleWrapper>
		<Avatar src={value.avatarUrl} size="small" appearance="square" />
		<span>{value.name}</span>
	</SingleWrapper>
);

export const MultiProjectOption = ({ value }: Props) => (
	<MultiWrapper>
		<Avatar src={value.avatarUrl} size="xsmall" appearance="square" />
		<span>{value.name}</span>
	</MultiWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SingleWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MultiWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.050'),
});
